import ClipLoader from 'react-spinners/ClipLoader';
import { LoaderWrapper } from './styles';
import { primaryColor } from '../../config/colors';

const Loader = ({ size = 150 }) => {
  return (
    <LoaderWrapper>
      <ClipLoader
        loading={true}
        size={size}
        color={primaryColor}
      />
    </LoaderWrapper>
  );
};

export default Loader;
